export default {
  participants: [],
  pagination: {},
  participant: {},
  logtransaction: {}
}
